import React from 'react';

import useAuth from "../hooks/useAuth";

function UserState({userState}) {
    switch (userState?.state) {
        case 'register':
            return (
                <RegiserState/>
            )
        case 'inactive_diet':
            return (
                <InactiveDiet/>
            )
        case 'active_diet':
            return (
                <ActiveDiet/>
            )
        case 'diet_expired':
            return (
                <DietExpired/>
            )
        case 'weight_processing_due_date':
            return (
                <DietWeightDueDate/>
            )
        case 'weight_processing':
            return (
                <DietWeightProcess/>
            )
        default:
            return (
                <RegiserState/>
            )
    }
}

function InactiveDiet(props) {
    return (
        <div className="mb-2 state-box">

            <h3 className="page-title text-center mt-2" style={{
                fontSize:17
            }}>
                هم اکنون در انتظار آماده شدن برنامه غذایی شما هستیم.
                </h3>
            <p className="page-hint text-center">
                اطلاعات شما تایید شد.
            </p>
        </div>
    );
}

function ActiveDiet(props) {
    return (
        <div className="mb-2 state-box">

            <h3 className="page-title text-center mt-2" style={{
                fontSize:17
            }}>
                هم اکنون می بایست در حال اجرا دوره باشید.
            </h3>
            <p className="page-hint text-center">
                برنامه غذایی شما فعال شد.

            </p>
        </div>
    );
}

function RegiserState(props) {
    return (
        <div className="mb-2 state-box">

            <h3 className="page-title text-center mt-2" style={{
                fontSize:17
            }}>
                هم اکنون در انتظار تایید اطلاعات شما هستیم.
            </h3>
            <p className="page-hint text-center">
                ثبت نام شما با موفقیت انجام شد.
            </p>
        </div>
    );
}

function DietExpired(props) {
    return (
        <div className="mb-2 state-box">

            <h3 className="page-title text-center mt-2" style={{
                fontSize:17
            }}>
                هم اکنون می توانید دوره خودتان را تمدید کنید.
            </h3>
            <p className="page-hint text-center">
                دوره شما به اتمام رسید.
            </p>
        </div>
    );
}

function DietWeightDueDate() {
    return (
        <div className="mb-2 state-box">

            <h3 className="page-title text-center mt-2" style={{
                fontSize:17
            }}>
                هم اکنون باید وزن جدیدتان را در سامانه ثبت کنید.
            </h3>
            <p className="page-hint text-center">
                موعد برنامه 15 روزه شما به اتمام رسید.

            </p>
        </div>
    )
}

function DietWeightProcess() {
    return (
        <div className="mb-2 state-box">

            <h3 className="page-title text-center mt-2" style={{
                fontSize:17
            }}>
                هم اکنون در انتظار بررسی وضعیت شما توسط پزشک هستیم.
            </h3>
            <p className="page-hint text-center">
                وزن جدیدتان ثبت شد.
            </p>
        </div>
    )
}

export default UserState;
